"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateLocalBatchItemTax = void 0;
const precisionMath_1 = require("./precisionMath");
const round_1 = __importDefault(require("./round"));
function calculateLocalOrderTax(order) {
    var _a;
    // 計算結果 未稅食物總價
    const result = {
        nonTaxableTotal: 0,
    };
    // 將 order.taxes 中各項用來加總的數值清空成 0
    (_a = order.taxes) === null || _a === void 0 ? void 0 : _a.forEach(tax => {
        tax.tax = 0;
        tax.taxableTotal = 0;
    });
    // 計算稅
    order.batches.forEach(batch => {
        batch.items.forEach(item => {
            calculateLocalBatchItemTax(item, order, result);
            item.setItems.forEach(setItem => {
                calculateLocalBatchItemTax(setItem, order, result);
            });
        });
    });
    return result;
}
exports.default = calculateLocalOrderTax;
function calculateLocalBatchItemTax(item, order, result) {
    var _a, _b, _c, _d, _e;
    let inclusiveTaxesPercents = 0;
    let exclusiveTaxesPercents = 0;
    const inclusiveTaxes = [];
    const exclusiveTaxes = [];
    item.isTaxable = false; // 判斷該食物是否該課稅, 預設為不課稅
    // 如果該食物有機會可課稅，則遍歷 order.taxes 找出對應的稅項
    if (((_a = item.taxSettingIds) !== null && _a !== void 0 ? _a : []).length > 0) {
        (_b = order.taxes) === null || _b === void 0 ? void 0 : _b.forEach(tax => {
            var _a, _b;
            if ((_b = (_a = item.taxSettingIds) === null || _a === void 0 ? void 0 : _a.includes(tax.id)) !== null && _b !== void 0 ? _b : false) {
                item.isTaxable = true; // 確定可課稅
                if (tax.isTaxInclusive) {
                    inclusiveTaxes.push(tax);
                    inclusiveTaxesPercents += tax.percent;
                }
                else {
                    exclusiveTaxes.push(tax);
                    exclusiveTaxesPercents += tax.percent;
                }
            }
        });
    }
    // 以下計算均不含 setItems，setItems 需要各自再呼叫 calculateLocalBatchItem 計算
    // 不含折扣餐點價格
    const totalWithoutDiscount = (_c = item.totalWithoutSetItemsWithoutDiscountModifiers) !== null && _c !== void 0 ? _c : 0;
    // 含折扣餐點價格
    const totalWithDiscount = (_d = item.totalWithoutSetItemsAfterOrderDiscount) !== null && _d !== void 0 ? _d : 0;
    // 不含折扣稅前價
    item.totalBeforeTaxWithoutDiscount = (0, precisionMath_1.divide)(totalWithoutDiscount, 1 + inclusiveTaxesPercents / 100);
    // 含折扣稅前價
    item.totalBeforeTax = (0, precisionMath_1.divide)(totalWithDiscount, 1 + inclusiveTaxesPercents / 100);
    const inclusiveTaxesAmount = (0, precisionMath_1.subtract)(totalWithDiscount, item.totalBeforeTax);
    const exclusiveTaxesAmount = (0, precisionMath_1.multiply)(item.totalBeforeTax, exclusiveTaxesPercents / 100);
    item.tax = (0, precisionMath_1.add)(inclusiveTaxesAmount, exclusiveTaxesAmount);
    // 更新 order.taxes 中各個稅項的 tax 和 taxableTotal
    inclusiveTaxes.forEach(tax => {
        var _a, _b, _c;
        const taxAmount = inclusiveTaxesPercents !== 0
            ? (0, precisionMath_1.multiply)(inclusiveTaxesAmount, tax.percent / inclusiveTaxesPercents)
            : 0;
        tax.tax = (0, precisionMath_1.add)((_a = tax.tax) !== null && _a !== void 0 ? _a : 0, taxAmount);
        tax.taxableTotal = (0, precisionMath_1.add)((_b = tax.taxableTotal) !== null && _b !== void 0 ? _b : 0, (_c = item.totalBeforeTax) !== null && _c !== void 0 ? _c : 0);
    });
    exclusiveTaxes.forEach(tax => {
        var _a, _b, _c;
        const taxAmount = exclusiveTaxesPercents !== 0
            ? (0, precisionMath_1.multiply)(exclusiveTaxesAmount, tax.percent / exclusiveTaxesPercents)
            : 0;
        tax.tax = (0, precisionMath_1.add)((_a = tax.tax) !== null && _a !== void 0 ? _a : 0, taxAmount);
        tax.taxableTotal = (0, precisionMath_1.add)((_b = tax.taxableTotal) !== null && _b !== void 0 ? _b : 0, (_c = item.totalBeforeTax) !== null && _c !== void 0 ? _c : 0);
    });
    // 如果該食物不課稅，則將其未稅總額加到結果中
    if (!item.isTaxable) {
        result.nonTaxableTotal = (0, precisionMath_1.add)(result.nonTaxableTotal, (_e = item.totalBeforeTax) !== null && _e !== void 0 ? _e : 0);
    }
    if (order.enableIntermediateRounding) {
        item.tax = (0, round_1.default)(item.tax, order.rounding.type, order.rounding.digits);
        item.totalBeforeTax = (0, round_1.default)(item.totalBeforeTax, order.rounding.type, order.rounding.digits);
        item.totalBeforeTaxWithoutDiscount = (0, round_1.default)(item.totalBeforeTaxWithoutDiscount, order.rounding.type, order.rounding.digits);
    }
    return item;
}
exports.calculateLocalBatchItemTax = calculateLocalBatchItemTax;
//# sourceMappingURL=calculateLocalOrderTax.js.map